import { render } from "./RestaurantView.vue?vue&type=template&id=8f0dca3c"
import script from "./RestaurantView.vue?vue&type=script&lang=js"
export * from "./RestaurantView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__